import { FC, useEffect, useState } from "react";
import { lddGlobalSessionInfo } from "../../../Components/navigationTypes";
import { useAppSelector } from "../../../redux/hooks";
import List from "../List/List";
import { FormListItem } from "../List/ListFuncs";
import { Badge, Dropdown } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { setShowRenewSession } from "../../../redux/reducer";

export type FileListColumn = {
    attrName: string;
    dataType: string;
    width: string;
    title: string;
}


const FormList: FC<{LSUCID?: string, subscribed?: boolean, loaded?: boolean}> = ({
    LSUCID,
    subscribed,
    loaded
  }) =>  {
    const SESSION_INFO: lddGlobalSessionInfo = useAppSelector((g) => g.SessionInfo);
    const dispatch = useDispatch();
    function handleFileEntryClick(fileEntry: FormListItem) {
        if (fileEntry.FileLink && fileEntry.FileLink > "") {
            window.open(`${process.env.REACT_APP_DSAPI_ENDPOINT}/docservice${fileEntry.FileLink}?SessionID=${SESSION_INFO.sid}`, '_blank');
        }
    }

    function getHighlightedText(text: string, highlight: string) {
        // Split on highlight term and include term into parts, ignore case
        const highlightText = highlight;
        if (text) {
            highlight = highlight.replace(/\\/g, "");
            highlight = highlight.replace(/\*/g, "\\*");
            highlight = highlight.replace(/\+/g, "\\+");
            highlight = highlight.replace(/\./g, "\\.");
            highlight = highlight.replace(/\?/g, "\\?");
            highlight = highlight.replace(/\[/g, "\\[");
            highlight = highlight.replace(/\]/g, "\\]");
            highlight = highlight.replace(/\{/g, "\\{");
            highlight = highlight.replace(/\}/g, "\\}");
            highlight = highlight.replace(/\(/g, "\\(");
            highlight = highlight.replace(/\)/g, "\\)");
            const parts = text.split(new RegExp(`(${highlight})`, 'gi'));
            return (
                <span>
                    {parts.map((part, i) =>
                        <span key={i} style={part.toLowerCase() === highlightText.toLowerCase() ? { fontWeight: 'bold' } : {}}>
                            {part}
                        </span>)
                    }
                </span>
            );
        } else {
            return <span></span>;
        }
    }
    
    function buildFileListLink(
        columns: FileListColumn[],
        searchText: string
    ) {
        return (fileEntry: FormListItem) => {
            return (
                <tr onClick={(e) => handleFileEntryClick(fileEntry)} key={fileEntry.FileName+fileEntry.FileNum}>
                    {columns.map((col, index) => {
                        if (col.attrName === "LeftIcon") {
                            return (
                                <td key={`${index}-${col.attrName}`}>
                                    <i className="fa-solid fa-file-pdf"></i>
                                </td>
                            )
                        }
                        else if (col.attrName === "FileName") {
                            return (
                                <td key={`${index}-${col.attrName}`}>
                                        {getHighlightedText(fileEntry[col.attrName], searchText)}
                                </td>
                            )
                        } else if (col.attrName === "HasSample") {
                            return (
                                <td  key={`${index}-${col.attrName}`}>
                                    {fileEntry[col.attrName] && 
                                     <Badge bg="inactive" text="dark" pill>
                                        Sample
                                     </Badge>
                                    }
                                </td>
                            )
                        } else if (col.attrName === "FileNum") {
                            return (
                                <td  key={`${index}-${col.attrName}`}>
                                    <Badge bg="info" text="dark" pill>
                                        {fileEntry[col.attrName]}
                                    </Badge>
                                </td>
                            )
                        } else if (col.attrName === "RightIcon") {
                            return (
                                <td key={`${index}-${col.attrName}`}>
                                    {subscribed &&
                                        <i className="fa-light fa-arrow-down-to-line"></i>
                                    }
                                </td>
                            )
                        }
                        return (
                            <td>
                            </td>
                        )
                    })}
                </tr>
            )
        }
    }

    function buildHead<T extends unknown>(
        columns: any[]
    ) {
        return (
            <tr>
                {columns.map(col => {
                    return (
                        <th key={`th-${col.attrName}`} data-name={col.attrName} style={{width: col.width}}>
                            {col.title}
                        </th>
                    )
                })}
                <th key="options"></th>
            </tr>
        )
    
    }

    async function fetchData(firmId: number, sid: string, LSUCID: string): Promise<any[]> {
        try {
            if (firmId && sid) {
                var reqLawyerID = "sample";
                if (subscribed && LSUCID && LSUCID > "" && LSUCID !== "sample") {
                    reqLawyerID = LSUCID;
                }
                const responseData = await fetch(`${process.env.REACT_APP_DSAPI_ENDPOINT}/docservice/forms/${firmId}/en/1/${reqLawyerID}?SessionID=${sid}`, {
                    method: "GET",
                    credentials: "include", // send user credentials for same origin and cors
                    headers: {
                        "Content-Type": "application/json"
                    },
                });
                if (responseData.ok) {
                    const data = await responseData.json();
                    if (data.ok) {
                        return data.result;
                    } else {
                        throw data.error;
                    }
                } else if (!responseData.ok && responseData.status == 403) {
                    dispatch(setShowRenewSession(true));
                }
            }
            return []
        } catch (e) {
            console.log(JSON.stringify(e))
            return []
        }
    }

    const [listColumns, setListColumns] = useState<any[]>(
        [
            {
                attrName: "LeftIcon",
                dataType: '',
                width: '5%',
                title: ''
            },
            {
                attrName: "FileName",
                dataType: '',
                width: '80%',
                title: 'OREA FORM'
            },
            {
                attrName: "HasSample", // Sample tag
                dataType: '',
                width: '6%',
                title: ''
            },
            {
                attrName: "FileNum",
                dataType: '',
                width: '6%',
                title: 'No.'
            },
            {
                attrName: "RightIcon",
                dataType: '',
                width: '5%',
                title: ''
            }
        ]);

    return (
        <>
            <List
                listName="FormList"
                FileListColumns={listColumns}
                handleLoadFileData={fetchData}
                buildFileListLink={buildFileListLink}
                buildHead={buildHead}
                LSUCID={LSUCID}
                loaded={loaded}
                subscribed={subscribed}
            />
        </>
    );
}

export default FormList;
